const { h, render, Component } = require('preact');
const {route} = require('preact-router')
const queryString = require('qs');

const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const DealImage      = require('./deal_image')
const DetailTable      = require('./detail_table')
const SSAButtons      = require('../self_service_actions/ssa_buttons')
const SSALinks      = require('../self_service_actions/ssa_links')
const ExternalDealNotes      = require('./external_deal_notes')
const ContextualSearch = require('../search/contextual_search_bar')
const ContextualArticles = require('../search/contextual_articles')
const ContactChannel      = require('../contact_us/contact_channels')
const SpinnerView = require('../../views/common/spinner')
const ErrorView = require('../main/error')
const Helper = require('../../../helper')

class OrderSummary extends Component {
  constructor(props) {
    super(props);
    this.createSummary = this.createSummary.bind(this)
    this.getExternalDealNotes = this.getExternalDealNotes.bind(this)
    this.getContactChannelParams = this.getContactChannelParams.bind(this)
    this.handleNeedHelpFromSearchResults = this.handleNeedHelpFromSearchResults.bind(this)
    this.getContactChannelsView = this.getContactChannelsView.bind(this)
    this.getContextualView = this.getContextualView.bind(this)
    this.showContextualArticlesExperience = this.showContextualArticlesExperience.bind(this)
    this.setState({'showContactChannels': false})
  }

  componentWillMount() {
    let orderId = this.props.order_id
    const voucherId = this.props.voucher_id;
    this.setState({'orderId': orderId});
    if(orderId){
      this.setState({'isOrderDetailsLoading':true});
      let ORDER = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/orders/${orderId}`
      if (voucherId) {
        ORDER = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/vouchers/${voucherId}`
      }

      let errorCb = () => {
        this.setState({orderDetails: null,'isOrderDetailsLoading':false, 'isFailure': true});
      }
      let successCb = (response) => {
        if(response)
        {
          this.setState({orderDetails: response,'isOrderDetailsLoading':false});
        }
      }
      SupportAPIHelper.get(ORDER, null, successCb, errorCb, false);
    }
  }

  componentDidMount() {
    let inbentaSessionToken = sessionStorage.getItem('inbentaSessionKey')
    if (!inbentaSessionToken || inbentaSessionToken === "null" || inbentaSessionToken === "undefined") {
      Helper.createSession();
    }
  }

  showContextualArticlesExperience() {
    return Groupon.Utils.getConfigFromDom().showContextualArticlesExperience;
  }


  getContactChannelParams(){
    let resultParams = queryString.parse(this.props);
    let params;
    if (this.props.showContactChannels){
      let qs = window.location.search.slice(1)
      params = queryString.parse(qs);
    }
    else if (this.state.selectedInbentaResult && this.state.orderDetails && this.state.orderId){
      params = this.state.selectedInbentaResult;
      params.selectedItem = this.state.orderDetails;
      params.selectedItem.order_id = this.state.orderId;
    }
    else if (resultParams.selectedInbentaResult && this.state.orderDetails && this.state.orderId) {
      params = resultParams.selectedInbentaResult;
      params.selectedItem = this.state.orderDetails;
      params.selectedItem.order_id = this.state.orderId;
    }
    return params;
  }

  handleNeedHelpFromSearchResults(selectedInbentaResult){
    this.setState({
      'selectedInbentaResult': selectedInbentaResult,
      'showContactChannels': true
    })
    route(`/customer_support/web/contact_channels?order_id=${this.state.orderId}`);
  }

  getContextualView(){
    if(this.props.pageType == 'contextual'){
      if(this.state.orderDetails.metadata && this.state.orderDetails.metadata.inbentaParams) {
          if (this.showContextualArticlesExperience()) {
            return <ContextualArticles inbentaParams={this.state.orderDetails.metadata.inbentaParams}
                                       handleNeedHelpFromSearchResults={this.handleNeedHelpFromSearchResults}
                                       orderId={this.state.orderId}/>
          }
          else {
            return <ContextualSearch inbentaParams = {this.state.orderDetails.metadata.inbentaParams} handleNeedHelpFromSearchResults = {this.handleNeedHelpFromSearchResults}/>
          }
      }
    }
  }

  getContactChannelsView(){
    if(this.props.pageType == 'contact_channels'){
      if(this.state.showContactChannels || this.props.showContactChannels || this.props.showContactChannelsFromContextualBar)
        return <ContactChannel contactChannelParams = {this.getContactChannelParams()} guestOrder={this.props.guestOrder}/>
      }
  }

  createSummary() {
    if(this.state.isOrderDetailsLoading)
      return (<SpinnerView/>)
    if (this.state.isFailure)
      return (<ErrorView/>)
    let summary = this.getContactChannelsView()
    if(this.state.orderDetails){
        summary =
          <div>
            <div class="twelve columns order-summary summary-padding">
              <div class ="row">
                <div class ="three columns first-section">
                  <DealImage dealDetails={this.state.orderDetails.deal}/>
                  <SSALinks orderDetails={this.state.orderDetails}/>
                </div>
                <div class ="six columns second-section">
                  <DetailTable orderDetails={this.state.orderDetails}/>
                </div>
                <div class ="three columns third-section">
                  <SSAButtons orderDetails={this.state.orderDetails}/>
                </div>
              </div>
            </div>
            {this.getContextualView()}
            {this.getContactChannelsView()}
          </div>
      }
      return summary;
  }

  getExternalDealNotes() {
    if(this.state.orderDetails){
      return <ExternalDealNotes orderDetails = {this.state.orderDetails} />;
    }
  }

  render() {
    return (
      <section className="main row cs_support_header" id="contact-us-body-content">
        <div className="twelve columns">
          <section className="module">
            <div className="module-body contact-us">
              <div className="row">
                <div id="help-wizard" class="help-wizard" style="display: block;">
                  {this.getExternalDealNotes()}
                  <div class = "help-wizard-content">
                    {this.createSummary()}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    );
  }
}
module.exports = OrderSummary
